import styled from '@emotion/styled';

import { Label } from '@/design-system';
import { CryptoAsset } from '@/shared/modules/wallet/use-crypto-assets';

import { SendAmountCard, SendRecipientCard, SendSummary } from './send-confirm-summary';
import { SendDivider } from './send-divider';
import type { ConfirmationRecipient } from './use-send-flow';

const NETWORK_LABEL = 'SUI';
const SPONSORED_GAS = 'Gas Fees are sponsored by Gamma Prime';

const Body = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing[16],
  width: '100%',
}));

const AmountSection = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing[8],
}));

export interface SendConfirmationProps {
  coin: CryptoAsset;
  amount: string;
  amountUsd: number | null;
  balanceLabel: string;
  confirmationRecipient: ConfirmationRecipient;
}

export const SendConfirmation = ({
  coin,
  amount,
  amountUsd,
  balanceLabel,
  confirmationRecipient,
}: SendConfirmationProps) => (
  <Body>
    <AmountSection>
      <Label topRightLabel={balanceLabel}>Amount</Label>
      <SendAmountCard coin={coin} amount={amount} amountUsd={amountUsd} />
    </AmountSection>
    <SendDivider />
    <AmountSection>
      <Label>Send to</Label>
      <SendRecipientCard recipient={confirmationRecipient} />
    </AmountSection>
    <SendSummary
      amount={amount}
      symbol={coin.symbol}
      recipientAddress={confirmationRecipient.address}
      network={NETWORK_LABEL}
      networkFee="0.00"
      feeTooltip={SPONSORED_GAS}
    />
  </Body>
);
